import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TransferAllocateService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-services';
import { TableError } from '../../types/common';

const usePutPendingTransferAllocatesShareForDrs = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void,
  onError?: (message: string, errors: TableError[]) => void
): UseMutationResult<Wealthlane_AwardService_Dtos_Response_ResponseDto, unknown, any, unknown> => {
  return useMutation(
    async (payload) => {
      return await handleRequest(
        TransferAllocateService.putApiAwardApiAppTransferAllocatePendingTransferAllocatesShareForDrs(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.success) {
          toast.success(
            <ToastComponent label='Success' message={`DRS Registration Details Edited.`} />
          );
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutPendingTransferAllocatesShareForDrs;
